import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGithubIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 26 26",
	style: { enableBackground: "new 0 0 26 26" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.github-st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M13,0L13,0c7.2,0,13,5.8,13,13l0,0c0,7.2-5.8,13-13,13l0,0C5.8,26,0,20.2,0,13l0,0C0,5.8,5.8,0,13,0z" }),
		/* @__PURE__ */ _jsx("path", {
			className: "github-st0",
			d: "M17,25.4c-1.3,0.4-2.6,0.6-4,0.6c-1.4,0-2.8-0.2-4-0.6c0.6,0.1,0.8-0.3,0.8-0.6c0-0.1,0-0.4,0-0.7 c0-0.4,0-0.9,0-1.5c-3.6,0.8-4.4-1.7-4.4-1.7c-0.6-1.5-1.4-1.9-1.4-1.9C2.8,18.1,4,18.1,4,18.1c1.3,0.1,2,1.3,2,1.3 c1.2,2,3,1.4,3.8,1.1c0.1-0.8,0.5-1.4,0.8-1.7c-2.9-0.3-5.9-1.4-5.9-6.4c0-1.4,0.5-2.6,1.3-3.5C5.9,8.5,5.5,7.2,6.2,5.4 c0,0,1.1-0.3,3.6,1.3c1-0.3,2.1-0.4,3.3-0.4c1.1,0,2.2,0.1,3.3,0.4c2.5-1.7,3.6-1.3,3.6-1.3c0.7,1.8,0.3,3.1,0.1,3.4 c0.8,0.9,1.3,2.1,1.3,3.5c0,5-3,6.1-5.9,6.4c0.5,0.4,0.9,1.2,0.9,2.4c0,1.2,0,2.2,0,2.8c0,0.3,0,0.6,0,0.7 C16.2,25.1,16.4,25.4,17,25.4z"
		})
	]
});
export default SvgGithubIcon;
